import type { IconData } from '@stacksjs/iconify-core'

export const vn4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGMXVQpcWp\"><path fill-opacity=\".7\" d=\"M-85.3 0h682.6v512H-85.3z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGMXVQpcWp)\" transform=\"translate(80)scale(.9375)\"><path fill=\"#da251d\" d=\"M-128 0h768v512h-768z\"/><path fill=\"#ff0\" d=\"M349.6 381L260 314.3l-89 67.3L204 272l-89-67.7l110.1-1l34.2-109.4L294 203l110.1.1l-88.5 68.4l33.9 109.6z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default vn4x3
